<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 col-gap-12 row-gap-11 items-center">
    <div class="lg:col-span-2">
      <div class="text-xl font-bold text-text leading-tight">{{ $t('formTitle') }}</div>
    </div>
    <BaseSelect v-model="country"
                :options="countriesList"
                :label="`name_${$i18n.locale}`"
                :select-label="$t('countryLabel')"
                track-by="code"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                @select="bank = null"/>
    <VueCtkDateTimePicker v-model="date"
                          format="YYYY-MM-DD"
                          formatted="L"
                          :label="$t('dateLabel')"
                          :locale="$i18n.locale"
                          :min-date="minDateStart"
                          :auto-close="true"
                          :only-date="true"
                          :no-label="false"
                          :no-clear-button="true"
                          :no-button="true"
                          color="#486680"/>
    <div class="lg:col-span-2">
      <MoreSettings class="ml-8 mt-1 px-2 relative z-10 bg-block"
                    :active="true"
                    :text="$t('pickBank')"/>
      <BankPicker :banks="countriesBanks"
                  :active-id="!!bank ? bank.id : null"
                  class="-mt-3"
                  @select="bank = $event"/>
    </div>
    <div class="lg:col-span-2 flex flex-wrap items-center">
      <BaseButton theme="red"
                  class="w-78 lg:w-91 mr-8"
                  :loading="submitted"
                  @click="add">
        {{ $t('addLabel') }}
      </BaseButton>
      <BaseButton theme="white"
                  class="w-50 lg:w-68 mt-8 lg:mt-0"
                  :loading="submitted"
                  @click="$emit('cancel')">
        {{ $t('cancel') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import BaseButton from "@/components/UI/BaseButton";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import MoreSettings from "@/components/common/MoreSettings";
import BankPicker from "@/components/cabinet/SpaceSettings/BanksIntegrations/BankPicker/BankPicker";

export default {
  name: "BanksIntegrationsForm",
  components: {BankPicker, MoreSettings, BaseSelect, BaseButton},
  data() {
    return {
      country: null,
      countriesList: [
        {code: 'RU', name_en: 'Russia', name_ru: 'Россия'},
        {code: 'UA', name_en: 'Ukraine', name_ru: 'Украина'},
        // {code: 'XF', name_en: 'Test', name_ru: 'Test'}
      ],
      bank: null,
      date: null,
      submitted: false
    }
  },
  computed: {
    ...mapGetters('space', ['spaceInfo']),
    ...mapGetters('space/banks', ['availableBanksList']),
    countriesBanks() {
      if (!this.country) {
        return this.availableBanksList
      }
      return this.availableBanksList.filter(bank => bank.country_code === this.country.code)
    },
    minDateStart() {
      return this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
    }
  },
  methods: {
    ...mapActions('space/banks', ['connectBank']),
    async add() {
      if (!this.bank) return this.$toasted.error('Выберите банк')
      try {
        this.submitted = true;
        const data = {
          space_id: this.spaceInfo.id,
          date: this.date,
          bank: this.bank.code
        }
        const res = await this.connectBank(data);
        if (res.body.success) {
          this.$emit('connect', {link: res.body.data, connection: this.bank})
        } else {
          this.$toasted.error('Что-то пошло не так')
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.submitted = false;
      }
    }
  },
  created() {
    this.country = this.countriesList[0];
    this.date = this.$moment().subtract(1, 'month').format('YYYY-MM-DD')
  },
  i18n: {
    messages: {
      en: {
        formTitle: 'Add bank',
        countryLabel: 'Country',
        dateLabel: 'Date from',
        pickBank: 'Select bank',
        addLabel: 'Add',
        cancel: 'Cancel'
      },
      ru: {
        formTitle: 'Добавление банка',
        countryLabel: 'Страна',
        dateLabel: 'Дата начала',
        pickBank: 'Выберите банк',
        addLabel: 'Подключить',
        cancel: 'Отмена'
      },
    }
  }
}
</script>